import loadable from "@loadable/component";


export default loadable(() => import(/* webpackChunkName: "expressCheckout.m" */ "./Loadable"));
